import { onBeforeUnmount, onMounted } from 'vue'

export type UseDetailsHotkeysHandlers = {
  onApprove: () => void
  onReject: () => void
  onDownload: () => void
  onNavigate: (direction: 'prev' | 'next') => void
  onStepAsset: (offset: number) => void
}

const isTypingTarget = (target: EventTarget | null) => {
  const element = target as HTMLElement | null
  return Boolean(
    element &&
    (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA' || element.isContentEditable),
  )
}

export const useDetailsHotkeys = (handlers: UseDetailsHotkeysHandlers) => {
  const handleKeydown = (event: KeyboardEvent) => {
    if (isTypingTarget(event.target)) {
      return
    }
    const withModifier = event.altKey || event.metaKey
    if (event.key === 'ArrowRight') {
      event.preventDefault()
      if (withModifier) {
        handlers.onStepAsset(1)
      } else {
        handlers.onNavigate('next')
      }
      return
    }
    if (event.key === 'ArrowLeft') {
      event.preventDefault()
      if (withModifier) {
        handlers.onStepAsset(-1)
      } else {
        handlers.onNavigate('prev')
      }
      return
    }
    if (withModifier || event.ctrlKey) {
      return
    }
    const actions: Record<string, (() => void) | undefined> = {
      a: handlers.onApprove,
      r: handlers.onReject,
      d: handlers.onDownload,
    }
    const action = actions[event.key.toLowerCase()]
    if (action) {
      event.preventDefault()
      action()
    }
  }

  onMounted(() => window.addEventListener('keydown', handleKeydown, true))
  onBeforeUnmount(() => window.removeEventListener('keydown', handleKeydown, true))
}
